import { useState, useCallback } from 'react'

export const useAccordionItem = (initialState: boolean = false) => {
  const [visible, setVisible] = useState(initialState)
  const handleVisible = useCallback(() => {
    setVisible((prev) => !prev)
  }, [])
  return { visible, handleVisible } as const
}
